var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-common-search',{attrs:{"value":_vm.params.keyword}}),_c('common-store-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }